

const env={
    // baseUrl:'https://www.versatilecommerce.com' || env.baseUrl,
    // baseUrlLocal:'http://'+window.location.host || env.baseUrl,
    baseUrl:'http://'+window.location.host || env.baseUrl,
}

export default env;